import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxGlideModule } from 'ngx-glide';
import { RatingsComponent } from 'src/app/hospitals/components/ratings/ratings.component';
import { UtilService } from 'src/app/shared/services';
import { SwiperConfigInterface, SwiperModule } from 'ngx-swiper-wrapper';

@Component({
  selector: 'app-hf-comments',
  standalone: true,
  imports: [
    CommonModule,
    NgxGlideModule,
    RatingsComponent,
    SwiperModule
  ],
  templateUrl: './hf-comments.component.html',
  styleUrls: ['./hf-comments.component.scss']
})
export class HfCommentsComponent {
  @Input() comments;
  constructor(
    public util: UtilService
  ) {}

  config: SwiperConfigInterface = {
    direction: 'horizontal',
    slidesPerView: 3,
    initialSlide: 3,
    navigation: false,
    keyboard: false,
    scrollbar: false,
    loop: false,
    autoplay: {
      delay: 2000,
      disableOnInteraction: true,
      waitForTransition: true
    },
    observer: true,
    preloadImages: false,
    spaceBetween: 16,
    centeredSlides: false,
    pagination: false,
    breakpoints: {
      992: {
        slidesPerView: 1,
        centeredSlides: false,
        allowTouchMove: true,
        loop: false,
        autoplay: {
          delay: 2000,
          disableOnInteraction: true,
          waitForTransition: true
        },
        observer: true,
      },
      768: {
        slidesPerView: 1,
        autoplay: {
          delay: 2000,
          disableOnInteraction: true,
          waitForTransition: true
        },
        initialSlide: 1,
      }
    }
  };

  getRatingsArr(ratings): string[] {
    const ratingsArr = [];
    const fullStars = Math.floor(ratings);
    const decimalPart = ratings - fullStars;
    for (let i = 0; i < fullStars; i++) {
      ratingsArr.push('/assets/images/health-first/hf-rating-full.svg');
    }
    if (decimalPart >= 0.75) {
      ratingsArr.push('/assets/images/health-first/hf-rating-full.svg');
    } else if (decimalPart >= 0.25) {
      ratingsArr.push('/assets/images/health-first/hf-rating-half.svg');
    }
    const emptyStars = 5 - ratingsArr.length; 
    for (let i = 0; i < emptyStars; i++) {
      ratingsArr.push('/assets/images/health-first/hf-rating-empty.svg');
    }
    return ratingsArr;
  }
}
